export const version = 'v2.2.4-2012-ga3d1a4e77'
